module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/websocket/lib/version.js
// module id = 1069
// module chunks = 0